import React from "react";
import { useNavigate } from "react-router-dom";
import PageContainer from "../../components/page-container";
import Button from "../../components/button";
import PageHeader from "../../components/page-header";

const Home = () => {
  const navigate = useNavigate();

  const handleStart = () => {
    navigate("/upload");
  };

  return (
    <PageContainer isShowIcon>
      <PageHeader
        title="Add classes to your calendar"
        description="Click below to begin adding classes to your calendar of choice"
      />

      <Button variant="primary" size="medium" onClick={handleStart}>
        Start
      </Button>
    </PageContainer>
  );
};

export default Home;
